import { GroupContext } from '../context';
import { AcceptInviteEvent } from './accept-invite.event';

export async function acceptInvite(evt: AcceptInviteEvent, ctx: GroupContext) {
  await ctx.state('groupMembers').patch({
    id: evt.groupMemberId,
    state: 'accepted',
  });
  if (ctx.metadata.auth) {
    await ctx.emit('revoke-access', {
      auth: ctx.metadata.auth,
      eventGrants: [{ event: 'accept-invite', access: 'write' }],
    });
    await ctx.emit('grant-access', {
      auth: ctx.metadata.auth,
      eventGrants: [
        { event: 'create-todo', filters: [], access: 'read' },
        { event: 'create-todo', filters: [], access: 'write' },
        { event: 'complete-todo', filters: [], access: 'read' },
        { event: 'complete-todo', filters: [], access: 'write' },
        { event: 'incomplete-todo', filters: [], access: 'read' },
        { event: 'incomplete-todo', filters: [], access: 'write' },
        { event: 'update-todo', filters: [], access: 'read' },
        { event: 'update-todo', filters: [], access: 'write' },
      ],
    });
  }
}
